import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsIconRegistry,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import {
    mdiAccountArrowLeft,
    mdiAccountBox,
    mdiAccountCircle,
    mdiAccountGroup,
    mdiAccountOutline,
    mdiArrowDown,
    mdiArrowLeftRight,
    mdiArrowRight,
    mdiArrowUp,
    mdiCheckboxBlank,
    mdiFlagVariant,
    mdiStar,
    mdiTarget,
} from '@mdi/js';

import { CmpsFlagComponent } from './flag-component/flag-component';
import { CmpsMetricPerformanceComponent } from './metric-performance.component';
import { CmpsMetricUserComponent } from './metric-user-component/metric-user-component';
import { CmpsMetricProgressBarComponent } from './progress-bar-component/metric-progress-bar.component';

@NgModule({
    declarations: [
        CmpsMetricPerformanceComponent,
        CmpsMetricProgressBarComponent,
        CmpsFlagComponent,
        CmpsMetricUserComponent,
    ],
    imports: [
        CmpsButtonModule,
        CmpsIconModule,
        CmpsTooltipModule,
        CommonModule,
    ],
    exports: [CmpsMetricPerformanceComponent, CmpsMetricUserComponent],
    entryComponents: [CmpsMetricPerformanceComponent],
})
export class CmpsMetricPerformanceModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['checkbox-blank', mdiCheckboxBlank],
            ['account-box', mdiAccountBox],
            ['target', mdiTarget],
            ['flag-variant', mdiFlagVariant],
            ['account-group', mdiAccountGroup],
            ['arrow-up', mdiArrowUp],
            ['arrow-down', mdiArrowDown],
            ['chevron-right', mdiArrowRight],
            ['chevron-down', mdiArrowDown],
            ['arrow-left-right', mdiArrowLeftRight],
            ['account-circle', mdiAccountCircle],
            ['star', mdiStar],
            ['account-outline', mdiAccountOutline],
            ['account-arrow-left', mdiAccountArrowLeft],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
